module.exports = __webpack_public_path__ + "frontend/img/icon_info_text.2636ecfd.svg";